import { inject, injectable } from "@launchtray/tsyringe-async";
import { Viewable } from "by/gamefactory/scene/viewable/Viewable";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { ILogger } from "by/gamefactory/cityversetycoon/logger/ILogger";
import { PromiseCompletionSource } from "by/gamefactory/shared/async/PromiseCompletionSource";
import { ILatestNewsController } from "../controllers/ILatestNewsController";
import { UserProfileResourcePackage } from "../../userprofile/resources/UserProfileResourcePackage";
import { ILatestNewsModel } from "../../../common/models/latestnews/ILatestNewsModel";
import { IPlayerModel } from "../../../common/models/IPlayerModel";
import { IGuestModel } from "../../../common/models/IGuestModel";
import { LatestNewsPopupView } from "../views/LatestNewsPopupView";
import { LatestNewsResourcePackage } from "../resources/LatestNewsResourcePackage";
import { CancellationToken } from "async/CancellationToken";
import { DynamicResourcesPackage } from "resources/DynamicResourcesPackage";
import { LatestNewsPopupSceneResult, LatestNewsResultOptions } from "../LatestNewsResultOptions";
import { GameInfo } from "by/gamefactory/analytics/GameInfo";
import { Web3Model } from "by/gamefactory/web3/models/Web3Model";
import { Web3Config } from "../../../../../web3/config/Web3Config";

@injectable()
export class LatestNewsPopupScene extends Viewable<LatestNewsResultOptions<LatestNewsPopupSceneResult>> {
    public constructor(
        @inject("ICanvasScaler") canvasScaler: ICanvasScaler,
        commonResources: CommonResourcesPackage,
        userProfileResources: UserProfileResourcePackage,
        @inject("ILogger") logger: ILogger,
        @inject("IPlayerModel") playerModel: IPlayerModel,
        @inject("IGuestModel") guestModel: IGuestModel,
        @inject("ILatestNewsController") newsController: ILatestNewsController,
        @inject("ILatestNewsModel") latestNewsModel: ILatestNewsModel,
        newsResources: LatestNewsResourcePackage,
        newsDynamicResources: DynamicResourcesPackage,
        cancellationToken: CancellationToken,
        gameInfo: GameInfo,
        web3Model: Web3Model,
        web3Config: Web3Config
    ) {
        super();
        const newsViewPCS = new PromiseCompletionSource<LatestNewsResultOptions<LatestNewsPopupSceneResult>>();
        this.view = new LatestNewsPopupView(
            newsViewPCS,
            cancellationToken,
            canvasScaler,
            newsResources,
            commonResources,
            userProfileResources,
            newsDynamicResources,
            playerModel,
            guestModel,
            newsController,
            latestNewsModel,
            logger,
            web3Config,
            web3Model
        );
        newsViewPCS.result.then((result: LatestNewsResultOptions<LatestNewsPopupSceneResult>) => {
            this.operationControls.complete(result);
            userProfileResources.destroy();
        }, (reason: any) => {
            this.operationControls.error(reason);
        });
    }
}
